import { Action } from '@ngrx/store'
import * as digitizationTypes from './digitization.types'

export class FetchBuildingRequest implements Action {
  readonly type = digitizationTypes.FETCH_BUILDING_REQUEST
  constructor(public id: any) {}
}

export class FetchBuildingSuccess implements Action {
  readonly type = digitizationTypes.FETCH_BUILDING_SUCCESS
  constructor(public payload: any) {}
}

export class FetchBuildingFailure implements Action {
  readonly type = digitizationTypes.FETCH_BUILDING_FAILURE
  constructor(public payload: any) {}
}

export class UpdateBuildingRequest implements Action {
  readonly type = digitizationTypes.UPDATE_BUILDING_REQUEST
  constructor(public buildingId: string, public payload: any) {}
}

export class UpdateBuildingSuccess implements Action {
  readonly type = digitizationTypes.UPDATE_BUILDING_SUCCESS
  constructor(public payload: any) {}
}

export class UpdateBuildingFailure implements Action {
  readonly type = digitizationTypes.UPDATE_BUILDING_FAILURE
  constructor(public payload: any) {}
}

export class CreateBuildingRequest implements Action {
  readonly type = digitizationTypes.CREATE_BUILDING_REQUEST
  constructor(public payload: any) {}
}

export class CreateBuildingSuccess implements Action {
  readonly type = digitizationTypes.CREATE_BUILDING_SUCCESS
  constructor(public payload: any) {}
}

export class CreateBuildingFailure implements Action {
  readonly type = digitizationTypes.CREATE_BUILDING_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = digitizationTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = digitizationTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | SetDefaultData
  | UpdateField
  | FetchBuildingRequest
  | FetchBuildingSuccess
  | FetchBuildingFailure
  | UpdateBuildingRequest
  | UpdateBuildingSuccess
  | UpdateBuildingFailure
  | CreateBuildingRequest
  | CreateBuildingSuccess
  | CreateBuildingFailure
